'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jsonrpcDispatch = require('jsonrpc-dispatch');

var _jsonrpcDispatch2 = _interopRequireDefault(_jsonrpcDispatch);

var _string = require('../lib/string');

var _events = require('events');

var _uri = require('../lib/uri');

var _uri2 = _interopRequireDefault(_uri);

var _logger = require('../lib/logger');

var _logger2 = _interopRequireDefault(_logger);

var _dimension = require('../lib/dimension');

var _mutationObserver = require('mutation-observer');

var _mutationObserver2 = _interopRequireDefault(_mutationObserver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Application class which represents an embedded application. */
var Application = function (_EventEmitter) {
  (0, _inherits3.default)(Application, _EventEmitter);

  function Application() {
    (0, _classCallCheck3.default)(this, Application);
    return (0, _possibleConstructorReturn3.default)(this, (Application.__proto__ || (0, _getPrototypeOf2.default)(Application)).apply(this, arguments));
  }

  (0, _createClass3.default)(Application, [{
    key: 'init',

    /**
     * init method
     * @param  options.acls            An array that contains white listed origins
     * @param  options.secret          A string or function used for authorization with Consumer
     * @param  options.onReady         A function that will be called after App is authorized
     * @param  options.targetSelectors A DOMString containing one or more selectors to match against.
     *                                 This string must be a valid CSS selector string; if it's not,
     *                                 a SyntaxError exception is thrown.
     */
    value: function init(_ref) {
      var _ref$acls = _ref.acls,
          acls = _ref$acls === undefined ? [] : _ref$acls,
          _ref$secret = _ref.secret,
          secret = _ref$secret === undefined ? null : _ref$secret,
          _ref$onReady = _ref.onReady,
          onReady = _ref$onReady === undefined ? null : _ref$onReady,
          _ref$targetSelectors = _ref.targetSelectors,
          targetSelectors = _ref$targetSelectors === undefined ? '' : _ref$targetSelectors;

      this.acls = [].concat(acls);
      this.secret = secret;
      this.onReady = onReady;
      this.targetSelectors = targetSelectors;
      this.resizeConfig = null;
      this.requestResize = this.requestResize.bind(this);
      this.handleConsumerMessage = this.handleConsumerMessage.bind(this);
      this.authorizeConsumer = this.authorizeConsumer.bind(this);
      this.verifyChallenge = this.verifyChallenge.bind(this);
      this.emitError = this.emitError.bind(this);
      this.unload = this.unload.bind(this);

      // Resize for slow loading images
      document.addEventListener('load', this.imageRequestResize.bind(this), true);

      var self = this;
      this.JSONRPC = new _jsonrpcDispatch2.default(self.send.bind(self), {
        event: function event(_event, detail) {
          self.emit(_event, detail);
          return _promise2.default.resolve();
        },
        resize: function resize() {
          var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          self.resizeConfig = config;

          self.requestResize();

          // Registers a mutation observer for body
          var observer = new _mutationObserver2.default(function (mutations) {
            return self.requestResize();
          });
          observer.observe(document.body, { attributes: true, childList: true, characterData: true, subtree: true });

          // Registers a listener to window.onresize
          // Optimizes the listener by debouncing (https://bencentra.com/code/2015/02/27/optimizing-window-resize.html#debouncing)
          var interval = 100; // Resize event will be considered complete if no follow-up events within `interval` ms.
          var resizeTimer = null;
          window.onresize = function (event) {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
              return self.requestResize();
            }, interval);
          };

          return _promise2.default.resolve();
        }
      });
    }

    /**
     * imageRequestResize function to call requestResize event for slow loading image
     * @param {object} event - event which triggered the listener
     */

  }, {
    key: 'imageRequestResize',
    value: function imageRequestResize(event) {
      var tgt = event.target;
      if (tgt.tagName === 'IMG' && !(tgt.hasAttribute('height') || tgt.hasAttribute('width'))) {
        this.requestResize();
      }
    }
  }, {
    key: 'requestResize',
    value: function requestResize() {
      if (!this.resizeConfig) return;
      if (this.resizeConfig.customCal) {
        this.JSONRPC.notification('resize');
      } else if (this.resizeConfig.autoResizeWidth) {
        var width = (0, _dimension.calculateWidth)(this.resizeConfig.WidthCalculationMethod);
        this.JSONRPC.notification('resize', [null, width + 'px']);
      } else {
        var height = (0, _dimension.calculateHeight)(this.resizeConfig.heightCalculationMethod);

        // If targetSelectors is specified from Provider or Consumer or both,
        // need to calculate the height based on specified target selectors
        if (this.targetSelectors || this.resizeConfig.targetSelectors) {
          // Combines target selectors from two sources
          var targetSelectors = [this.targetSelectors, this.resizeConfig.targetSelectors].filter(function (val) {
            return val;
          }).join(', ');

          var heights = [].slice.call(document.querySelectorAll(targetSelectors)).map(_dimension.getOffsetHeightToBody);

          height = Math.max.apply(Math, (0, _toConsumableArray3.default)(heights).concat([height]));
        }

        this.JSONRPC.notification('resize', [height + 'px']);
      }
    }

    /**
    * Triggers an event in the parent application.
    * @param {string} event - The event name to trigger.
    * @param {object} detail - The data context to send with the event.
    */

  }, {
    key: 'trigger',
    value: function trigger(event, detail) {
      this.JSONRPC.notification('event', [event, detail]);
    }

    /**
    * Request to mount an application fullscreen.
    * @param {string} url - The url of the application to mount.
    */

  }, {
    key: 'fullscreen',
    value: function fullscreen(url) {
      this.trigger('xfc.fullscreen', url);
    }

    /**
     * Sends http errors to consumer.
     * @param  {object} error - an object containing error details
     */

  }, {
    key: 'httpError',
    value: function httpError() {
      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.trigger('xfc.provider.httpError', error);
    }

    /**
     * Request to load a new page of given url
     * @param  {string} url - The url of the new page.
     */

  }, {
    key: 'loadPage',
    value: function loadPage(url) {
      this.JSONRPC.notification('loadPage', [url]);
    }

    /**
    * Launches the provider app and begins the authorization sequence.
    */

  }, {
    key: 'launch',
    value: function launch() {
      if (window.self !== window.top) {
        // 1: Setup listeners for all incoming communication and beforeunload
        window.addEventListener('message', this.handleConsumerMessage);
        window.addEventListener('beforeunload', this.unload);

        // 2: Begin launch and authorization sequence
        this.JSONRPC.notification('launch');

        // 2a. We have a specific origin to trust (excluding wildcard *),
        // wait for response to authorize.
        if (this.acls.some(function (x) {
          return x !== '*';
        })) {
          this.JSONRPC.request('authorizeConsumer', []).then(this.authorizeConsumer).catch(this.emitError);

          // 2b. We don't know who to trust, challenge parent for secret
        } else if (this.secret) {
          this.JSONRPC.request('challengeConsumer', []).then(this.verifyChallenge).catch(this.emitError);

          // 2c. acl is '*' and there is no secret, immediately authorize content
        } else {
          this.authorizeConsumer();
        }

        // If not embedded, immediately authorize content
      } else {
        this.authorizeConsumer();
      }
    }

    /**
    * Handles an incoming message event by processing the JSONRPC request
    * @param {object} event - The emitted message event.
    */

  }, {
    key: 'handleConsumerMessage',
    value: function handleConsumerMessage(event) {
      // Ignore Non-JSONRPC messages or messages not from the parent frame
      if (!event.data.jsonrpc || event.source !== window.parent) {
        return;
      }

      _logger2.default.log('<< provider', event.origin, event.data);
      // For Chrome, the origin property is in the event.originalEvent object
      var origin = event.origin || event.originalEvent.origin;
      if (!this.activeACL && this.acls.indexOf(origin) !== -1) {
        this.activeACL = origin;
      }

      if (this.acls.indexOf('*') !== -1 || this.acls.indexOf(origin) !== -1) {
        this.JSONRPC.handle(event.data);
      }
    }

    /**
    * Send the given message to the frame parent.
    * @param {object} message - The message to send.
    */

  }, {
    key: 'send',
    value: function send(message) {
      // Dont' send messages if not embedded
      if (window.self === window.top) {
        return;
      }

      if (this.acls.length < 1) {
        _logger2.default.error('Message not sent, no acls provided.');
      }

      if (message) {
        _logger2.default.log('>> provider', this.acls, message);
        if (this.activeACL) {
          parent.postMessage(message, this.activeACL);
        } else {
          this.acls.forEach(function (uri) {
            return parent.postMessage(message, uri);
          });
        }
      }
    }

    /**
    * Verify the challange made to the parent frame.
    * @param {string} secretAttempt - The secret string to verify
    */

  }, {
    key: 'verifyChallenge',
    value: function verifyChallenge(secretAttempt) {
      var _this2 = this;

      var authorize = function authorize() {
        _this2.acls = ['*'];
        _this2.authorizeConsumer();
      };

      if (typeof this.secret === 'string' && (0, _string.fixedTimeCompare)(this.secret, secretAttempt)) {
        authorize();
      } else if (typeof this.secret === 'function') {
        return this.secret.call(this, secretAttempt).then(authorize);
      }
      return _promise2.default.resolve();
    }

    /**
    * Authorize the parent frame by unhiding the container.
    */

  }, {
    key: 'authorizeConsumer',
    value: function authorizeConsumer() {
      document.documentElement.removeAttribute('hidden');

      // Emit a ready event
      this.emit('xfc.ready');
      this.JSONRPC.notification('authorized', [{ url: window.location.href }]);

      // If there is an onReady callback, execute it
      if (typeof this.onReady === 'function') {
        this.onReady.call(this);
      }
    }

    /**
     * Emit the given error
     * @param  {object} error - an error object containing error code and error message
     */

  }, {
    key: 'emitError',
    value: function emitError(error) {
      this.emit('xfc.error', error);
    }
  }, {
    key: 'unload',
    value: function unload() {
      // These patterns trigger unload events but don't actually unload the page
      var protocols = /^(tel|mailto|fax|sms|callto):/;
      var element = document.activeElement;

      if (!element || !(element.hasAttribute && element.hasAttribute('download') || protocols.test(element.href))) {
        this.JSONRPC.notification('unload');
        this.trigger('xfc.unload');
      }
    }
  }]);
  return Application;
}(_events.EventEmitter);

exports.default = Application;


//////////////////
// WEBPACK FOOTER
// ./node_modules/xfc/lib/provider/application.js
// module id = 149
// module chunks = 0